import React from 'react';
import { InsightHero as InsightHeroType } from '../aiInsightsTypes';
import styles from './InsightHero.module.css';

interface InsightHeroProps {
  data: InsightHeroType;
}

export const InsightHero: React.FC<InsightHeroProps> = ({ data }) => {
  return (
    <div className={styles.card}>
      <div className={styles.titleRow}>
        <span className={styles.iconCircle}>✨</span>
        <div>
          <h2 className={styles.title}>AI-Powered Insights</h2>
          <p className={styles.subtitle}>
            Actionable recommendations to maximize your sales performance
          </p>
        </div>
      </div>
      <div className={styles.statsRow}>
        <div className={styles.stat}>
          <p className={styles.statValue}>{data.activeInsights}</p>
          <p className={styles.statLabel}>Active Insights</p>
        </div>
        <div className={styles.stat}>
          <p className={styles.statValue}>{data.highPriority}</p>
          <p className={styles.statLabel}>High Priority</p>
        </div>
        <div className={styles.stat}>
          <p className={styles.statValue}>{data.avgConfidence}</p>
          <p className={styles.statLabel}>Avg Confidence</p>
        </div>
      </div>
    </div>
  );
};
